export const sidebarHideRoutes = ["support-tickets"];
